import React from 'react';
import styled from 'styled-components';

const Picture = ({ src, webp, altText, png, gif }) => {
    const StyledImage = styled.img`
        height: auto;
        width: auto;
        max-width: 100%;
    `;

    return (
        <picture>
            {webp ? <source srcSet={webp} type='image/webp' /> : null}
            {gif ? <source srcSet={gif} type='image/gif' /> : null}
            <StyledImage src={src} alt={altText || 'image'} />
        </picture>
    );
};

export default Picture;



// WEBPACK FOOTER //
// ./src/components/image/Picture.js